<template>
  <div class="side-nav">
    <ul class="func-list">
      <li class="item">
        <div class="slide-layout">
          <div class="slide-wrapper">
            <div class="normal">
              <img class="icon" :src="cfg.ossDomain + '/phone.png'">
              <span class="text">小程序</span>
            </div>
            <div class="active">
              <img class="icon" :src="cfg.ossDomain + '/phone_hover.png'">
              <span class="text">小程序</span>
            </div>
          </div>
        </div>
        <!-- <img class="qr-code" :src="cfg.ossDomain + '/bxgz_qr.jpg'"> -->
      </li>
      <li class="item">
        <div class="slide-layout">
          <div class="slide-wrapper">
            <div class="normal">
              <img class="icon" :src="cfg.ossDomain + '/wechat.png'">
              <span class="text">公众号</span>
            </div>
            <div class="active">
              <img class="icon" :src="cfg.ossDomain + '/wechat_hover.png'">
              <span class="text">公众号</span>
            </div>
          </div>
        </div>
        <img class="qr-code" :src="cfg.ossDomain + '/wechat_qr.png'">
      </li>
      <li class="item">
        <div class="slide-layout">
          <div class="slide-wrapper">
            <div class="normal">
              <img class="icon" :src="cfg.ossDomain + '/weibo.png'">
              <span class="text">官方微博</span>
            </div>
            <a class="active" href="https://weibo.com/u/6889326358" target="_blank">
              <img class="icon" :src="cfg.ossDomain + '/weibo_hover.png'">
              <span class="text">官方微博</span>
            </a>
          </div>
        </div>
      </li>
      <a v-if="backupShow" class="backup" href="#">
        <img class="icon" :src="cfg.ossDomain + '/back_top.png'">
      </a>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      backupShow: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const sideBarMain = document.querySelector('.side-bar-main').offsetTop;
      if (scrollTop > sideBarMain) {
        this.backupShow = true;
      } else {
        this.backupShow = false;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.side-nav{
  position: fixed;
  top: 50%;
  right: 40px;
  transform: translateY(-50%);
  .func-list{
    // padding-left: 134px;
    height: 304px;
    list-style: none;
    .item {
      position: relative;
      .slide-layout{
        width: 72px;
        overflow: hidden;
      }
      .slide-wrapper{
        position: relative;
        display: inline-flex;
        margin-bottom: 4px;
        transition: all .2s linear;
        .active,.normal{
          width: 72px;
          height: 72px;
          background: #FFFFFF;
          border: 1px solid #E5E5E5;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .icon{
            width: 36px;
            height: 36px;
          }
          .text{
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            margin-top: 4px;
            color: #999999;
          }
        }
        &:hover{
          transform: translateX(-72px);
        }
      }
      &:hover .qr-code{
        display: block !important;
      }
    }
    .backup {
      transition: all .5s in;
      .icon{
        width: 72px;
        height: 72px;
      }
    }
    .qr-code{
      position: absolute;
      left: -134px;
      width: 130px;
      height: 130px;
      top: 0;
      display: none;
      transition: all .2s linear;
    }
  }
}
</style>
